<template>
  <div class="mapWrap">
    <div class="player_div">
      <button @click="click_player()">播放</button>
    </div>
  </div>
</template>

<script>
import * as turf from '@turf/turf'
import { STATUS_LIST } from '../../assets/js/constant.js'
import FlyIcon from '../../assets/img/map/fly.png'
import CarIcon from '../../assets/img/map/cats.png'
const mapboxgl = require('mapbox-gl')
export default {
  name: 'Draw_map',
  data () {
    return {
      order_type: '',
      STATUS_LIST,
      map: null,
      PointArr: [], // 描线坐标点数组
      NowArr: [],
      cathome: [], // 卡车开始运输轨迹
      caten: [], // 卡车配送轨迹
      ACCESS_TOKEN:
        'pk.eyJ1IjoieWl6dW8iLCJhIjoiY2trZXV6eWE0MDAzdzJ1cXBrb3hrNXBhZCJ9.PYOAiCMUh-oFuz2hGdKZlA',
      mapStyle: 'mapbox://styles/mapbox/streets-v11',
      pointData: {},
      isPlay: false,
      index: 0,
      transform_list: [], // 中转机场数组
      depart_port_latitude: '', // 起点坐标经度
      depart_port_longitude: '', // 起点坐标纬度
      arrive_port_latitude: '', // 到达机场坐标经度
      arrive_port_longitude: '', // 到达机场坐标纬度
      transfer_port_latitude: '', // 中转坐标经度
      transfer_port_longitude: '', // 中转坐标纬度
      actual_arrive_time: '', // 飞机实际到达时间
      arrive_port_name_cn: '', // 到达机场名称
      depart_port_name_cn: '', // 起飞机场名称
      transfer_port_name_cn: '', // 中转机场名称
      playerTrack: [],
      radius: '',
      animatePointGeoJson: {
        type: 'FeatureCollection',
        features: [
          {
            type: 'Feature',
            properties: {},
            geometry: {
              type: 'Point',
              coordinates: [] // 根据接口返回的坐标值绘画轨迹
            }
          }
        ]
      },
      iconsize: 0.3,
      newRouteGeoJson: {
        type: 'FeatureCollection',
        features: [
          {
            type: 'Feature',
            properties: {},
            geometry: {
              type: 'Point',
              coordinates: [] // 根据接口返回的坐标值绘画轨迹1
            }
          }
        ]
      }
    }
  },
  props: ['collRes', 'giveRes', 'trackInfo'],
  computed: {
    hasEndList () {
      return (
        this.trackInfo.give_res &&
        this.trackInfo.give_res.give_data &&
        this.trackInfo.give_res.give_lat
      )
    },
    hasStartList () {
      return (
        this.trackInfo.coll_res &&
        this.trackInfo.coll_res.coll_data &&
        this.trackInfo.coll_res.coll_lat
      )
    },
    showTruck () {
      return (
        (this.hasStartList && !this.trackInfo.coll_res.is_give) ||
        (this.hasEndList && !this.trackInfo.give_res.is_give)
      )
    }
  },

  created () {
    this.order_type = this.trackInfo.type

    for (let i = 0; i < this.trackInfo.route_list.length; i++) {
      if (i + 1 < this.trackInfo.route_list.length) {
        if (
          this.trackInfo.route_list[i].arrive_port_three_no ==
          this.trackInfo.route_list[i + 1].depart_port_three_no
        ) {
          var data = {
            arrive_port_latitude:
              this.trackInfo.route_list[i].arrive_port_latitude,
            arrive_port_longitude:
              this.trackInfo.route_list[i].arrive_port_longitude,
            arrive_port_name_cn:
              this.trackInfo.route_list[i].arrive_port_name_cn,
            arrive_port_three_no:
              this.trackInfo.route_list[i].arrive_port_three_no,
            arrive_port_time_zone:
              this.trackInfo.route_list[i].arrive_port_time_zone,
            actual_arrive_time: this.trackInfo.route_list[i].actual_arrive_time,
            actual_depart_time:
              this.trackInfo.route_list[i + 1].actual_depart_time,
            plan_arrive_time: this.trackInfo.route_list[i].plan_arrive_time,
            plan_depart_time: this.trackInfo.route_list[i + 1].plan_depart_time
          }
          this.transform_list.push(data)
        }
      }
    }
    if (this.trackInfo.actual_arrive_time == '') {
      this.trackInfo.actual_arrive_time = this.trackInfo.state_ld_time
    }
    if (this.trackInfo.actual_depart_time == '') {
      this.trackInfo.actual_depart_time = this.trackInfo.state_qf_time
    }
    // 当航段中 起点没有起飞时间 ， 终点没有落地时间的时候 ，取运单的起飞时间和落地时间
    if (this.trackInfo.route_list[0].actual_depart_time == '') {
      this.trackInfo.route_list[0].actual_depart_time = this.trackInfo.actual_depart_time
    }
    if (this.trackInfo.route_list[this.trackInfo.route_list.length - 1].actual_arrive_time == '') {
      this.trackInfo.route_list[this.trackInfo.route_list.length - 1].actual_arrive_time = this.trackInfo.actual_arrive_time
    }
  },
  mounted () {
    this.init()
    this.getPlanPoint()
  },
  methods: {
    getCenter (one, two) {
      var center = 0
      if ((one > 0 && two > 0) || (one < 0 && two < 0)) { // 如果两个经度的符号相同  那么中点就是相加除2
        center = (one + two) / 2
      } else if ((Math.abs(one) + Math.abs(two)) < 180) {
        center = (one + two) / 2
      } else { // 如果两经度点绝对值超过180度  //master
        let a = 180 - Math.abs(one)
        let b = 180 - Math.abs(two)
        let c = (a + b) / 2
        if (one > 0) {
          center = one + c
        } else {
          center = one - c
        }
      }
      return center
    },
    getRadius (start, end) {
      // 获取两点之间的角度，作用于车子，飞机的朝向

      return turf.bearing(turf.point(start), turf.point(end))
    },
    // mapbox://styles/mapbox/streets-v11
    init () {
      mapboxgl.accessToken = this.ACCESS_TOKEN
      this.map = new mapboxgl.Map({
        container: 'map',
        style: 'https://mapbox.f.yizuo.ltd/api/styles/style',
        center: [0, 0],
        antialias: false,
        minZoom: '1.5',
        pitchWithRotate: false,
        dragRotate: false
      })
    },
    // 处理数组数据

    getNewData (arr, type) {
      var res = []
      var head = []
      var body = []
      var tail = []
      // res:总结果 head头程,body航段，tail尾程1
      const {
        depart_port_latitude,
        depart_port_longitude,
        arrive_port_latitude,
        arrive_port_longitude,
        actual_arrive_time,
        actual_depart_time,
        coll_res,
        give_res,
        coll_truck_track,
        give_truck_track,
        route_list,
        track_data
      } = this.trackInfo
      // 首先我们把整个航线分为三段，头程（汽车）,航段(飞机),尾程(汽车)
      // 添加航段坐标信息下面开始操作
      // 首先 如果有航段，且没有拉取到轨迹,把航段的信息给添加进去
      if (route_list.length > 0) {
        // 如果没有拉取到航段轨迹
        if (track_data.length <= 0) {
          route_list.forEach((i, index) => {
            if (index == 0) { // 如果是航段的第一段，即起飞点-中转/起飞点-终点  那么起飞时间要用外层的实际起飞时间，其实与careate中补时间的写法重复了，但是不影响，改怕改出其他问题
              // 且如果是第一段，起点要看看有没有收货时间
              body.push(
                {
                  name: i.depart_port_name_cn,
                  latitude: i.depart_port_latitude,
                  longitude: i.depart_port_longitude,
                  updateType: '常规点',
                  arrive_time: coll_res.give_time || this.trackInfo.state_sh_time,
                  depart_time: actual_depart_time,
                  type: '中转'
                },
                {
                  name: i.arrive_port_name_cn,
                  latitude: i.arrive_port_latitude,
                  longitude: i.arrive_port_longitude,
                  updateType: '常规点',
                  arrive_time: i.actual_arrive_time,
                  depart_time: '',
                  type: '中转'
                }
              )
            } else {
              body.push(
                {
                  name: i.depart_port_name_cn,
                  latitude: i.depart_port_latitude,
                  longitude: i.depart_port_longitude,
                  updateType: '常规点',
                  arrive_time: '',
                  depart_time: i.actual_depart_time,
                  type: '中转'
                },
                {
                  name: i.arrive_port_name_cn,
                  latitude: i.arrive_port_latitude,
                  longitude: i.arrive_port_longitude,
                  updateType: '常规点',
                  arrive_time: i.actual_arrive_time,
                  depart_time: '',
                  type: '中转'
                }
              )
            }
            // 这里是push的两个点进去，一个航段有两个点。注意看清
          })
        } else {
          // 如果拉取到了航段轨迹
          route_list.forEach((j, num) => {
            // 如果该段拉取到了相对应的轨迹，则添加轨迹   num相对应的第几段航段 ， track[num] ：第几段轨迹  是相对应的 xxx
            if (track_data[num] && track_data[num].length > 0) {
              track_data[num].forEach((k) => {
                body.push({
                  latitude: k.latitude || k.lat,
                  longitude: k.longitude || k.lon,
                  arrive_time: '',
                  depart_time: '',
                  updateType: '轨迹点',
                  type: '中转'
                })
              })
            } else {
              body.push(
                {
                  name: j.depart_port_name_cn,

                  latitude: j.depart_port_latitude,
                  longitude: j.depart_port_longitude,
                  updateType: '常规点',
                  arrive_time: j.actual_arrive_time,
                  depart_time: j.actual_depart_time,
                  type: '中转'
                },
                {
                  name: j.arrive_port_name_cn,
                  latitude: j.arrive_port_latitude,
                  longitude: j.arrive_port_longitude,
                  updateType: '常规点',
                  arrive_time: j.actual_arrive_time,
                  depart_time: j.actual_depart_time,
                  type: '中转'
                }
              )
            }
          })
        }
      }

      // 添加头程
      if (coll_res.coll_data.length != 0 && coll_truck_track.length <= 0) {
        head.push({
          latitude: coll_res.coll_lat,
          longitude: coll_res.coll_lng,
          updateType: '常规点',
          arrive_time: coll_res.give_time,
          depart_time: coll_res.coll_time,
          type: '揽收点'
        })
      } else if (coll_truck_track.length > 0) {
        coll_truck_track.forEach((i) => {
          let longitude = parseFloat(i.lon)
          let latitude = parseFloat(i.lat)
          head.push({
            latitude: latitude,
            longitude: longitude,
            arrive_time: '',
            depart_time: '',
            icon: 'useCar',
            updateType: '轨迹点',
            type: '揽收点'
          })
        })
      }

      // 添加尾程     也要添加双点，因为考虑到轨迹的原因，尾程在最后面前面可能会有轨迹所以加双点用于衔接，头程不必
      if (give_res.give_data.length != 0 && give_truck_track.length <= 0) {
        tail.push(
          {
            latitude: arrive_port_latitude,
            longitude: arrive_port_longitude,
            updateType: '常规点',
            arrive_time: actual_arrive_time,
            depart_time: give_res.coll_time,
            type: '中转'
          }, {
            latitude: give_res.give_lat,
            longitude: give_res.give_lng,
            updateType: '常规点',
            arrive_time: give_res.give_time,
            depart_time: '',
            type: '送货点'
          })
      } else if (give_truck_track.length > 0) {
        give_truck_track.forEach((i) => {
          let longitude = parseFloat(i.lon)
          let latitude = parseFloat(i.lat)
          tail.push({
            latitude: latitude,
            longitude: longitude,
            icon: 'useCar',
            updateType: '轨迹点',
            type: '送货点',
            arrive_time: '',
            depart_time: ''
          })
        })
      }
      res = [...head, ...body, ...tail]
      return res
    },
    // 播放
    click_player () {
      this.isPlay = true
      this.index = 0
      this.animate()
      // this.click_players();
      // this.click_playerst();
    },
    click_players () {
      this.isPlay = true
      this.index = 0
      this.click_playerst()
    },
    click_playerst () {
      this.isPlay = true
      this.index = 0
      this.animate()
    },
    // 处理跨0时区的数据
    getNewPointData (data) {
      var newArrList = []
      for (var i = 0; i < data.length; i++) {
        var str = ''
        if (data[i].pos) {
          if (data[i].pos[0] < 0) {
            str = {
              // 0: data[i].pos[0] + 360,
              // 1: data[i].pos[1],
              pos: [data[i].pos[0] + 360, data[i].pos[1]],
              type: data[i].type,
              line: data[i].line
            }
          } else {
            str = {
              // 0: data[i].pos[0],
              // 1: data[i].pos[0],
              pos: [data[i].pos[0], data[i].pos[1]],
              type: data[i].type,
              line: data[i].line
            }
          }
        } else {
          if (data[i][0] < 0) {
            str = {
              0: data[i][0] + 360,
              1: data[i][1]
            }
          } else {
            str = {
              0: data[i][0],
              1: data[i][1]
            }
          }
        }

        newArrList.push(str)
      }
      return newArrList
    },
    // 画出历史轨迹
    huaHistroy () {
      // 历史轨迹
      const { map } = this
      var geojsonHistory = {
        type: 'FeatureCollection',
        features: [
          {
            type: 'Feature',
            geometry: {
              type: 'LineString',
              properties: {},
              coordinates: this.PointArr
            }
          }
        ]
      }
      map.addSource('LineString', {
        type: 'geojson',
        data: geojsonHistory
      })
      map.addLayer({
        id: 'LineString',
        type: 'line',
        source: 'LineString',
        layout: {
          'line-join': 'round',
          'line-cap': 'round'
        },
        paint: {
          'line-color': '#a6c5c2', // 这里是轨迹的颜色
          'line-opacity': 1,
          'line-width': 3 // 这里是轨迹的线宽
        }
      })
      map.on('click', 'LineString', (e) => {
        const _zoom = Math.max(map.getZoom(), 2)
        map.setCenter(e.lngLat)
        map.setZoom(_zoom)
        map.panBy([-5000 / _zoom, -1000 / _zoom])
      })
    },

    //  建议去看mapbox，https://docs.mapbox.com/mapbox-gl-js/example/animate-point-along-route/
    animate (a) {
      const {
        index,
        NowArr,
        newRouteGeoJson,
        animatePointGeoJson,
        map,
        animate,
        showTruck
      } = this

      const steps = NowArr.length
      if (index === NowArr.length) {
        this.isPlay = false
        return
      }
      var startPnt, endPnt

      if (index == 0) {
        startPnt = newRouteGeoJson.features[0].geometry.coordinates[index]
        endPnt = newRouteGeoJson.features[0].geometry.coordinates[index + 1]
      } else if (index !== 0) {
        startPnt = newRouteGeoJson.features[0].geometry.coordinates[index - 1]
        endPnt = newRouteGeoJson.features[0].geometry.coordinates[index]
        if (endPnt != undefined) {
          animatePointGeoJson.features[0].properties.bearing = this.getRadius(startPnt, endPnt) - 45 // 计算两点间的角度 因为图片本身歪了45度
          animatePointGeoJson.features[0].geometry.coordinates =
            newRouteGeoJson.features[0].geometry.coordinates[index]
          if (this.order_type == '普通卡运') {
            map.setLayoutProperty(
              'animatePointLayer',
              'icon-image',
              'truckIcon'
            )
          } else {
            if (NowArr[index]) {
              var icontype = NowArr[index].type
              var backIconType = NowArr[index - 1].type
              var line = NowArr[index].line
            }
            if (icontype === '揽收坐标') {
              map.setLayoutProperty(
                'animatePointLayer',
                'icon-image',
                'truckIcon'
              )
            } else if (
              (icontype === '中转' ||
                icontype === '飞机终点' ||
                icontype === '飞机起点') &&
              backIconType === '中转' &&
              line != 'no'
            ) {
              if (index === NowArr.length - 1) {
                map.setLayoutProperty('animatePointLayer', 'icon-image', 'carIcon') // 这里是画飞机图标
              }
              map.setLayoutProperty('animatePointLayer', 'icon-image', 'carIcon') // 这里是画飞机图标
            } else if (line == 'no') {
              return
            } else {
              map.setLayoutProperty(
                'animatePointLayer',
                'icon-image',
                'truckIcon'
              ) // 这里是画汽车图标
            }
          }

          map.getSource('animatePointLayer').setData(animatePointGeoJson)
        }
      }
      map.setFilter('track-line', ['==', 'index', index])

      this.index = index + 1

      if (this.isPlay) {
        requestAnimationFrame(animate)
      }
    },

    // 绘线
    loadPgxData (result) {
      const { NowArr, map } = this
      console.log(NowArr, 11111)

      if (
        NowArr[NowArr.length - 1].type == '飞机起点' ||
        NowArr[NowArr.length - 1].type == '揽收点' ||
        NowArr[NowArr.length - 1].type == '送货点'
      ) {
        // 因为车子比较大，所以用0.3
        this.iconsize = 0.3
      } else {
        // 当图片显示为飞机的时候，显示0.5大小，飞机比较小
        this.iconsize = 0.3
      }
      var geojson = {
        type: 'FeatureCollection',
        features: []
      }
      var points = [[NowArr[0].pos[0], NowArr[0].pos[1]]]

      var p, _points
      for (var i = 0; i < NowArr.length; i++) {
        var p = [NowArr[i].pos[0], NowArr[i].pos[1]]
        var _points = points.concat([p])
        geojson.features.push({
          type: 'Feature',
          geometry: {
            type: 'LineString',
            coordinates: _points
          },
          properties: {
            index: i
          }
        })
        this.animatePointGeoJson.features[0].geometry.coordinates.push(p)
        this.newRouteGeoJson.features[0].geometry.coordinates.push(p)
        points.push(p)
      }

      map.addSource('track-line', {
        type: 'geojson',
        lineMetrics: true,
        data: geojson
      })
      map.addLayer(
        {
          id: 'track-line',
          type: 'line',
          source: 'track-line',
          paint: {
            'line-color': '#3b8e9f', // 这里是动画轨迹的颜色
            'line-width': 3 // 这里是动画轨迹的线宽
          }
        },
        'arrowLayer'
      )

      map.addLayer({
        id: 'animatePointLayer',
        type: 'symbol',
        source: {
          type: 'geojson',
          data: this.animatePointGeoJson
        },
        layout: {
          'icon-image': 'carIcon',
          'icon-size': this.iconsize,
          'icon-padding': 100,
          'icon-rotate': ['get', 'bearing'],
          'icon-rotation-alignment': 'map',
          'icon-allow-overlap': true,
          'icon-ignore-placement': true,
          'text-offset': [0, -5]
        }
      })
      this.click_player()
      // this.animate();
    },
    // 标签内容显示在地图上
    getLablePostion () {
      const {
        transfer_port_longitude,
        transfer_port_latitude,
        depart_port_longitude,
        depart_port_latitude,
        depart_port_name_cn,
        transfer_port_name_cn,
        arrive_port_longitude,
        arrive_port_latitude,
        arrive_port_name_cn,
        map,
        route_list,
        collRes,
        giveRes,
        order_type
      } = this

      var geojsonLabel = {}
      // 地图添加 出发点  到达点mark

      const features = [
        {
          name: 'depart',
          type: 'Feature',
          geometry: {
            type: 'Point',
            coordinates: [depart_port_longitude, depart_port_latitude]
          },
          properties: {
            title: depart_port_name_cn,
            description: `起飞时间：${this.trackInfo.actual_depart_time}`,
            three_no: this.trackInfo.depart_port_three_no,
            address_type: 'sfg',
            type: '始发港'
          }
        },
        {
          name: 'arrive',
          type: 'Feature',
          geometry: {
            type: 'Point',
            coordinates: [arrive_port_longitude, arrive_port_latitude]
          },
          properties: {
            title: arrive_port_name_cn,
            description: `到达时间：${this.trackInfo.actual_arrive_time || this.trackInfo.state_ld_time
            }`,
            three_no: this.trackInfo.arrive_port_three_no,
            address_type: 'mdg',
            type: '目的港'
          }
        }
      ]
      // 地图添加中转点 mark
      if (this.transform_list.length > 0) {
        this.transform_list.forEach((i, index) => {
          features.splice(index + 1, 0, {
            name: 'transfer',
            type: 'Feature',
            geometry: {
              type: 'Point',
              coordinates: [i.arrive_port_longitude, i.arrive_port_latitude]
            },
            properties: {
              title: i.arrive_port_name_cn,
              description: `起飞时间：${i.actual_depart_time}`,
              three_no: this.trackInfo.arrive_port_three_no,
              address_type: 'zzg',
              type: '中转港'
            }
          })
        })
      }
      // 地图添加头程点mark
      if (collRes && collRes.coll_lng) {
        features.unshift({
          name: 'coll',
          type: 'Feature',
          geometry: {
            type: 'Point',
            coordinates: [collRes.coll_lng, collRes.coll_lat]
          },
          properties: {
            title: collRes.coll_address,
            description: `揽收时间：${collRes.coll_time || collRes.expect_coll_time
            }`,
            address_type: 'fhd',
            type: '发货地'
          }
        }, {
          name: 'coll',
          type: 'Feature',
          geometry: {
            type: 'Point',
            coordinates: [collRes.give_lng, collRes.give_lat]
          },
          properties: {
            title: collRes.give_address,
            description: `收货时间：${collRes.give_time || collRes.expect_give_time
            }`,
            address_type: 'shd',
            type: '收货地'
          }
        })
      }
      // 地图添加尾程点mark

      if (giveRes && giveRes.give_lat) {
        features.push({
          name: 'give',
          type: 'Feature',
          geometry: {
            type: 'Point',
            coordinates: [giveRes.give_lng, giveRes.give_lat]
          },
          properties: {
            title: giveRes.give_address,
            description: `送达时间：${giveRes.give_time}`,
            address_type: 'qsd',
            type: '签收地'
          }
        })
      }
      geojsonLabel = {
        type: 'FeatureCollection',
        features
      }

      geojsonLabel.features.forEach(function (marker, index) {
        // create a HTML element for each feature
        // 此处为给地图上添加mark标记点  el就是标记点的样式  然后看是空运订单 还是卡运订单 添加两种订单不同的样式

        if (order_type == '普通卡运') { // 卡运订单的样式
          var el = document.createElement('div')
          el.className = `markerCar ${marker.properties.address_type}`
        } else { // 非卡运订单的样式
          var el = document.createElement('div')
          el.className = `marker ${marker.name}`
        }

        // index % 2 === 0 ? "top-right" : "bottom-left"
        // 标记点右边的信息提示框的样式 同样也分两种
        if (order_type == '普通卡运') {
          if (marker.properties.three_no) {
            new mapboxgl.Popup({
              closeOnClick: false,
              closeButton: false,
              anchor: 'bottom-left'
            })
              .setLngLat(marker.geometry.coordinates)
              .setHTML(
                `
			    <div class="carLabel ${marker.properties.address_type}">
			      <p class='left'>${marker.properties.type}</p>
			      <p class='right'>${marker.properties.three_no}</p>
			    </div>
			  `
              )
              .addTo(map)
          } else {
            new mapboxgl.Popup({
              closeOnClick: false,
              closeButton: false,
              anchor: 'bottom-left'
            })
              .setLngLat(marker.geometry.coordinates)
              .setHTML(
                `
			    <div class="carLabel_plus ${marker.properties.address_type}">
			     ${marker.properties.type}
			    </div>
			  `
              )
              .addTo(map)
          }
        } else {
          new mapboxgl.Popup({
            closeOnClick: false,
            closeButton: false,
            anchor: 'bottom-left'
          })
            .setLngLat(marker.geometry.coordinates)
            .setHTML(
              `
			    <div class="trackLineLabel ${marker.name}">
			      <p>${marker.properties.title}</p>
			      <p class='text'>${marker.properties.description}</p>
			    </div>
			  `
            )
            .addTo(map)
        }
        new mapboxgl.Marker(el)
          .setLngLat(marker.geometry.coordinates)
          .addTo(map)
      })
    },

    getCenterGPS (l1, l2) {
      console.log('中心点偏移')
      if (l1 < 0) {
        l1 = 360 + l1
      }
      if (l2 < 0) {
        l2 = 360 + l2
      }
      // if (l2 < 0) {
      //   l2 = 360 + l2;
      // }
      // TODO 根据浏览器宽度求值1
      // 将中心点右移 1/2 -> 2/3 (x+30/x)*1/2   hahah
      const clientWidth = document.body.clientWidth
      const diff = ((l2 + l1) * 1) / 2
      if (diff > 180) {
        return diff - 360
      } else {
        return diff
      }
    },

    // 添加箭头图层
    addArrowlayer () {
      const { map } = this
      // let routeGeoJson = {
      //   type: "FeatureCollection",
      //   features: [{
      //     type: "Feature",
      //     geometry: {
      //       type: "LineString",
      //       properties: {},
      //       coordinates: this.PointArr,
      //     },
      //   }, ],
      // };
      map.addLayer({
        id: 'arrowLayer',
        type: 'symbol',
        source: {
          type: 'geojson',
          data: {} // 轨迹geojson格式数据
        },
        layout: {
          'symbol-placement': 'line',
          'symbol-spacing': 40, // 图标间隔，默认为250
          'icon-image': 'arrowIcon', // 箭头图标1
          'icon-size': 0.5
        }
      })
    },

    /** * 根据订单状态 设置地图中心点 */
    setMapCenter (map) {
      console.log('规划地图中心点')
      const { trackInfo, STATUS_LIST, getCenterGPS, giveRes } = this

      // 需求为 如果是卡运订单 就定位在 卡车所在位置，如果是空运订单就定位在出发点跟结束点的中点位置
      let one = [trackInfo.depart_port_longitude, trackInfo.depart_port_latitude]
      let two = [trackInfo.arrive_port_longitude, trackInfo.arrive_port_latitude]
      let centerlongitude = this.getCenter(Number(one[0]), Number(two[0]))
      let centerlatitude = parseFloat((Number(one[1]) + Number(two[1])) / 2)
      if (this.order_type == '普通卡运') {
        centerlongitude = this.NowArr[this.NowArr.length - 1].pos[0]
        centerlatitude = this.NowArr[this.NowArr.length - 1].pos[1]
      }

      let center = [centerlongitude, centerlatitude]

      const {
        state,
        depart_port_longitude,
        depart_port_latitude,
        arrive_port_longitude,
        arrive_port_latitude
      } = trackInfo || {}
      const currentIndex = STATUS_LIST.indexOf(state)
      var lng, lat
      let zoom = 1
      if (
        (state == '已订舱' ||
          state == '已发出' ||
          state == '已收货' ||
          state == '已安检' ||
          state == '已入库' ||
          state == '已组板') &&
        Number(
          this.collRes &&
          this.collRes.coll_data &&
          this.collRes.coll_data.length
        ) > 0
      ) {
        // 已订舱、已发出、已收货、已安检、已入库、已组板 （且需要头程卡运） ：按发货点坐标和起飞机场坐标，计算中心点和放大比例显示
        lng = getCenterGPS(+this.collRes.coll_lng, +depart_port_longitude)
        lat = (+this.collRes.coll_lat + +depart_port_latitude) / 2
        zoom = 4
        console.log(
          '已订舱、已发出、已收货、已安检、已入库、已组板 （且需要头程卡运） ：按发货点坐标和起飞机场坐标',
          zoom
        )
      } else if (
        (state == '已落地' || state == '已提货') &&
        Number(
          this.giveRes &&
          this.giveRes.give_data &&
          this.giveRes.give_data.length
        ) > 0 &&
        this.giveRes.give_time == ''
      ) {
        // 已落地、已提货 （且需要尾程卡运、无送达时间 ）：按降落机场和送达地址的坐标计算中心点和放大比例显示
        if (this.giveRes.give_lng > 0) {
          // 按降落机场和送达地址的坐标计算中心点和放大比例显示
          lng = getCenterGPS(+arrive_port_longitude, +this.giveRes.give_lng)
          lat = (+arrive_port_latitude + +this.giveRes.give_lat) / 2
          zoom = 4
        } else {
          // 如果尾程没有经纬度   判断是否有头程 显示全流程
          if (
            Number(
              this.collRes &&
              this.collRes.coll_data &&
              this.collRes.coll_data.length
            ) > 0
          ) {
            lng = getCenterGPS(+this.collRes.coll_lng, +arrive_port_longitude)
            lat = (+this.collRes.coll_lat + +arrive_port_latitude) / 2
          } else {
            lng = getCenterGPS(+depart_port_longitude, +arrive_port_longitude)
            lat = (+depart_port_latitude + +arrive_port_latitude) / 2
          }
          zoom = 1
        }
        console.log(
          '已落地、已提货 （且需要尾程卡运、无送达时间 ）：按降落机场和送达地址的坐标',
          zoom,
          lng,
          lat
        )
      } else if (
        (state == '已落地' || state == '已提货') &&
        Number(
          this.giveRes &&
          this.giveRes.give_data &&
          this.giveRes.give_data.length
        ) > 0 &&
        this.giveRes.give_time != '' &&
        Number(
          this.collRes &&
          this.collRes.coll_data &&
          this.collRes.coll_data.length
        ) > 0
      ) {
        // 已落地、已提货 （且需要尾程卡运、有送达时间，有头程）：按头程的揽收地点和送达地址的坐标
        if (this.giveRes.give_lng > 0) {
          // 如果尾程经纬度：按头程的揽收地点和送达地址的坐标
          console.log('1', this.giveRes.give_lng)
          lng = getCenterGPS(+this.collRes.coll_lng, +this.giveRes.give_lng)
          lat = (+this.collRes.coll_lat + +this.giveRes.give_lat) / 2
        } else {
          // 如果没有经纬度，按头程的揽收地点和降落机场的坐标
          console.log('2', this.giveRes.give_lng)
          lng = getCenterGPS(+this.collRes.coll_lng, +arrive_port_longitude)
          lat = (+this.collRes.coll_lat + +arrive_port_latitude) / 2
        }
        zoom = 1
        console.log(
          '已落地、已提货 （且需要尾程卡运、有送达时间，有头程）：按头程的揽收地点和送达地址的坐标',
          zoom
        )
      } else if (
        (state == '已落地' || state == '已提货') &&
        Number(
          this.giveRes &&
          this.giveRes.give_data &&
          this.giveRes.give_data.length
        ) > 0 &&
        this.giveRes.give_time != '' &&
        this.collRes.coll_data.length <= 0
      ) {
        // 已落地、已提货 （且需要尾程卡运，有送达时间，无头程）：按起运机场和送达地址的坐标
        lng = getCenterGPS(+depart_port_longitude, +this.giveRes.give_lng)
        lat = (+depart_port_latitude + +this.giveRes.give_lat) / 2
        zoom = 1
        console.log(
          '已落地、已提货 （且需要尾程卡运，有送达时间，无头程）：按起运机场和送达地址的坐标',
          zoom
        )
      } else if (
        (state == '已落地' || state == '已提货') &&
        this.giveRes.give_data.length <= 0 &&
        Number(
          this.collRes &&
          this.collRes.coll_data &&
          this.collRes.coll_data.length
        ) > 0
      ) {
        // 已落地、已提货 （不需要尾程卡运，有头程）：按头程的揽收地点 和降落机场的坐标
        lng = getCenterGPS(+this.collRes.coll_lng, +arrive_port_longitude)
        lat = (+this.collRes.coll_lat + +arrive_port_latitude) / 2
        zoom = 1
      } else {
        lng = getCenterGPS(+depart_port_longitude, +arrive_port_longitude)
        lat = (+depart_port_latitude + +arrive_port_latitude) / 2
        console.log('其他', zoom)
      }
      // 如何放大，我采取的方法是根据起飞点跟中心点之间的经度差大小来定， 两点之间精度差在 0-10,10-20,20-30，>30  各是不同比例，这个比例没有具体规定，看情况来吧1
      let distans = this.halfDistans(center[0], Number(depart_port_longitude))
      if (distans < 10) {
        zoom = 4
      } else if (distans > 10 && distans < 20) {
        zoom = 3
      } else if (distans > 20 && distans < 30) {
        zoom = 2
      } else {
        if (this.order_type == '普通卡运') {
          zoom = 3
        } else {
          zoom = 1
        }
      }
      // 设置地图中心点

      map.setZoom(zoom)
      map.setCenter(center)

      map.panBy([-220 / zoom, zoom])
    },
    halfDistans (x, y) {
      if (x < 0) {
        x = x + 360
      }
      if (y < 0) {
        y = y + 360
      }
      let distans = Math.abs(x - y)
      return distans
    },
    // 显示图标icon
    markerPostion (flyShow) {
      let _this = this
      const {
        map,
        huaHistroy,
        setMapCenter,
        loadPgxData,
        addArrowlayer,
        showTruck
      } = this
      if (flyShow) {
        this.getLablePostion()
      }
      map.on('load', function () {
        setMapCenter(map)

        map.loadImage(FlyIcon, function (error, FlyIcon) {
          if (FlyIcon) {
            map.addImage('carIcon', FlyIcon)
            loadPgxData()
          }
        })

        map.loadImage(CarIcon, function (error, carIcon) {
          if (carIcon) {
            map.addImage('truckIcon', carIcon)
          }
        })
        // 箭头-右
        let svgXML = `<svg viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg">
			          <path d="M529.6128 512L239.9232 222.4128 384.7168 77.5168 819.2 512 384.7168 946.4832 239.9232 801.5872z" p-id="9085" fill="#ffffff"></path>
			      </svg>
			      `
        // 给图片对象写入base64编码的svg流
        let svgBase64 =
          'data:image/svg+xml;base64,' +
          window.btoa(unescape(encodeURIComponent(svgXML)))
        let arrowIcon = new Image(20, 20)
        arrowIcon.src = svgBase64
        arrowIcon.onload = function () {
          map.addImage('arrowIcon', arrowIcon)
          // huaHistroy();
          addArrowlayer()
        }
      })
    },

    // 执行绘制
    async getPlanPoint () {
      console.log('执行绘制')
      const { trackInfo } = this
      try {
        console.log('开始进行绘制判断')
        // 以起飞机场名为判断条件
        if (trackInfo !== undefined) {
          if (trackInfo.depart_port_name_cn !== undefined) {
            this.PointArr = []
            let track_data, history_track_data
            let historyResult, result
            this.depart_port_name_cn = trackInfo.depart_port_name_cn
            this.arrive_port_name_cn = trackInfo.arrive_port_name_cn
            this.transfer_port_name_cn = trackInfo.transfer_port_name_cn
            this.depart_port_latitude = trackInfo.depart_port_latitude // 起点坐标经度
            this.depart_port_longitude = trackInfo.depart_port_longitude // 起点坐标纬度
            this.arrive_port_latitude = trackInfo.arrive_port_latitude // 到达机场坐标经度
            this.arrive_port_longitude = trackInfo.arrive_port_longitude // 到达机场坐标纬度
            this.transfer_port_latitude = trackInfo.transfer_port_latitude // 中转坐标经度
            this.transfer_port_longitude = trackInfo.transfer_port_longitude // 中转坐标纬度
            this.actual_arrive_time = trackInfo.actual_arrive_time // 实际到达时间

            if ((track_data = trackInfo.track_data).length > 0) {
              console.log('第二个有航班轨迹，类型为2')
              result = this.getNewData(track_data, 2)
            }
            if (trackInfo.track_data.length <= 0) {
              console.log('第二个无航班轨迹，类型为2')

              result = this.getNewData(
                [
                  [
                    {
                      latitude: '',
                      longitude: '',
                      updateType: '1'
                    }
                  ]
                ],
                2
              )
            }
            if (
              trackInfo.track_data == undefined ||
              trackInfo.track_data == null ||
              (trackInfo.track_data.length <= 0 && this.hasStartList)
            ) {
              console.log('第三个无航班轨迹有头程 类型为2')

              result = this.getNewData(
                [
                  [
                    {
                      latitude: '',
                      longitude: '',
                      updateType: '1'
                    }
                  ]
                ],
                2
              )
            }

            if (!trackInfo.track_data && this.hasEndList) {
              console.log('第四个无航班轨迹 有尾程轨迹，类型为 2')
              result = this.getNewData(
                [
                  [],
                  [
                    {
                      latitude: trackInfo.arrive_port_latitude,
                      longitude: trackInfo.arrive_port_longitude,
                      updateType: '2'
                    }
                  ]
                ],
                2
              )
              result.pop()
            }

            const { arrive_port_longitude, depart_port_longitude } = this
            // 显示历史轨迹并画出路线

            if (historyResult != undefined && historyResult.length > 0) {
              this.playerTrack = historyResult
              for (var i = 0; i < historyResult.length; i++) {
                var longitude = parseFloat(historyResult[i].longitude)
                var latitude = parseFloat(historyResult[i].latitude)
                var listTemp = [longitude, latitude]
                this.PointArr.push(listTemp)
              }
              if (depart_port_longitude < 0 || arrive_port_longitude < 0) {
                if (
                  Math.abs(depart_port_longitude) +
                  Math.abs(arrive_port_longitude) >
                  180 &&
                  (arrive_port_longitude < 0 || depart_port_longitude < 0)
                ) {
                  this.PointArr = this.getNewPointData(this.PointArr)
                }
              }
              if (result == undefined && result.length == 0) {
                this.playerTrack = historyResult
                this.markerPostion(true)
              }
            } else if (
              historyResult == undefined &&
              result != undefined &&
              result.length > 0
            ) {
              this.playerTrack = result
              // 没有历史轨迹则画出当前轨迹线路

              for (var i = 0; i < result.length; i++) {
                if (
                  result[i].longitude != undefined &&
                  result[i].latitude != undefined
                ) {
                  var longitude = parseFloat(result[i].longitude)
                  var latitude = parseFloat(result[i].latitude)
                  var listTemp = [longitude, latitude]
                  // 将点添加进数组,绘制地图是以点形式绘制
                  this.PointArr.push(listTemp)
                }
              }
              this.transform_list.forEach((i, index) => {
                let tlongitude = parseFloat(i.arrive_port_longitude)
                let tlatitude = parseFloat(i.arrive_port_latitude)
                let transarr = [tlongitude, tlatitude]
                this.PointArr.splice(index + 1, 0, transarr)
              })
              if (depart_port_longitude < 0 || arrive_port_longitude < 0) {
                if (
                  Math.abs(depart_port_longitude) +
                  Math.abs(arrive_port_longitude) >
                  180 &&
                  (arrive_port_longitude < 0 || depart_port_longitude < 0)
                ) {
                  this.PointArr = this.getNewPointData(this.PointArr)
                }
              }
            }

            // 显示飞机当前已行驶的轨迹

            if (result != undefined && result.length > 0) {
              this.playerTrack = result

              console.log(result, 'result')
              // 一定先把第一个点加上，因为地图原因如果没有点，地图组件会默认为没有点的坐标就是（0，0） 然而0,0在地图上也是一个点
              this.NowArr.push({
                pos: [Number(result[0].longitude), Number(result[0].latitude)],
                type: result[0].type,
                line: 'no'
              })
              // 遍历result,先看点的类型，是轨迹点还是正常点,如果是轨迹点就不用考虑画半线的问题
              // 记录该节点后面是否有时间节点  只要remenber为true 前面的都画全线
              for (let i = 0; i < result.length; i++) {
                var remenber = false// 用以纪录此节点后续节点有没有时间，如果有时间，则后续节点要画全线，没有时间，则具体情况具体分析
                for (var k = i; k < result.length; k++) {
                  if (
                    (result[k].arrive_time != '' && result[k].arrive_time != undefined) ||
                    (result[k].depart_time != '' && result[k].depart_time != undefined)
                  ) {
                    remenber = true
                  }
                }
                let item = result[i] // 该节点

                if (i > 0) {
                  var backItem = result[i - 1] // 该节点的上一个节点
                }
                if (item.updateType == '轨迹点') {
                  var longitude = parseFloat(item.longitude)
                  var latitude = parseFloat(item.latitude)
                  var listTemp = [longitude, latitude]
                  this.NowArr.push({
                    pos: listTemp,
                    type: item.type,
                    line: 'yes'
                  })
                } else {
                  // 现在这里就是该点是常规点，要考虑画半线还是全线问题了
                  // 现在看上一个点的类型，如果上一个点是轨迹点就直接添加
                  if (!!backItem && backItem.updateType == '轨迹点') {
                    var longitude = parseFloat(item.longitude)
                    var latitude = parseFloat(item.latitude)
                    var listTemp = [longitude, latitude]
                    this.NowArr.push({
                      pos: listTemp,
                      type: item.type,
                      line: 'yes'
                    })
                  } else if (!!backItem && backItem.updateType == '常规点') {
                    // 如果上一个点是常规点，那么现在来细分画半线或画全线的情况
                    // 如果1.后面节点有时间，那么这个点直接画全线 2.前面节点和该节点是同一个节点直接添加3.如果前节点有起飞时间，此节点有落地时间,至于名字为什么要一样我也忘记了时间长了
                    if (
                      remenber ||
                      (item.name == backItem.name && item.name != undefined && backItem.name != undefined) ||
                      (!!backItem.depart_time && !!item.arrive_time)
                    ) {
                      var longitude = parseFloat(item.longitude)
                      var latitude = parseFloat(item.latitude)
                      var listTemp = [longitude, latitude]
                      this.NowArr.push({
                        pos: listTemp,
                        type: item.type,
                        line: 'yes'
                      })
                      // 如果后面没有时间节点，且上一节点有起飞时间，此节点没有落地时间说明在飞行途中画半线，跳出循环
                    } else if (
                      !remenber &&
                      !!backItem.depart_time &&
                      !item.arrive_time
                    ) {
                      // var longitude = this.getCenterGPS(
                      //   Number(backItem.longitude),
                      //   Number(item.longitude)
                      // );

                      var longitude = this.getCenter(Number(backItem.longitude), Number(item.longitude))
                      var latitude = parseFloat(
                        (Number(backItem.latitude) + Number(item.latitude)) / 2
                      )
                      var listTemp = [longitude, latitude]
                      console.log('画半线', listTemp)
                      this.NowArr.push({
                        pos: listTemp,
                        type: item.type,
                        line: 'yes'
                      })
                      break
                      // 如果后面没有时间节点，且上一节点没有起飞时间，此节点没有落地时间，那就不画线，把上一节点添加进去结束即可。结束循环11111
                    } else {
                      var longitude = parseFloat(backItem.longitude)
                      var latitude = parseFloat(backItem.latitude)
                      var listTemp = [longitude, latitude]
                      this.NowArr.push({
                        pos: listTemp,
                        type: backItem.type,
                        line: 'no'
                      })
                      break
                    }
                  }
                }
              }
              // 此处如果跨了半球，把数据代入进行数据跨时区处理
              if (depart_port_longitude < 0 || arrive_port_longitude < 0) {
                if (
                  Math.abs(depart_port_longitude) +
                  Math.abs(arrive_port_longitude) >
                  180 &&
                  (arrive_port_longitude < 0 || depart_port_longitude < 0)
                ) {
                  this.NowArr = this.getNewPointData(this.NowArr)
                }
              }
            }
            // this.playerTrack = [...historyResult,...result];

            this.markerPostion(true)
          }
        }
      } catch (err) {
        console.log('error', err)
      }
    }
  }
}
</script>

<style lang="less">
@import url("./index.less");

.player_div {
  position: absolute;
  top: 125px;
  right: 40px;
  z-index: 99;
}

.mapboxgl-popup-content {
  position: relative;
  background: transparent;
  border-radius: 3px;
  box-shadow: none;
  padding: 10px 10px 15px;
  pointer-events: auto;
  border: 0;
  padding: 6px;
}

.text {
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/components/draw_map/draw_map.vue